<script>
import autoLogin from '@/components/AutoLogin/TheseAutoLogin.vue'
export default autoLogin
</script>
